import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom'

import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material'

import { SetOptional } from 'type-fest'

import LinkUtils from '@utils/links'

type LinkProps = MuiLinkProps &
  SetOptional<RouterLinkProps, 'to'> & {
    label?: string
  }

const TLGLink = ({ to, children, label, rel, ...rest }: LinkProps) => {
  const getRel = () =>
    [rel, LinkUtils.getLinkRel()].filter(Boolean).join(' ').trim() || undefined

  return (
    <MuiLink
      rel={getRel()}
      {...(to && { component: RouterLink, to })}
      {...rest}
    >
      {label}
      {children}
    </MuiLink>
  )
}
export { TLGLink }
